import { combineReducers } from 'redux';

import categoriesReducer from 'src/redux/reducers/categories';
import advicesReducer from 'src/redux/reducers/advices';
import tabsReducer from 'src/redux/reducers/tabs';
import configReducer from 'src/redux/reducers/config';


export default combineReducers({
  configReducer,
  tabsReducer,
  advicesReducer,
  categoriesReducer
});
